import React, { useMemo } from "react";
import "../Components/css/blogD.css";
import "./PublicPageState.css";
import { Container } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SetMeeting from "../Components/SetMeeting";
import Navbar2 from "../Components/Navbar2";
import NotFound from "./NotFound";
import { blogSlug } from "../seo/publicSeo";

export default function BlogD({ posts = [], loading = false, error = false, onRetry }) {
  const { name = "" } = useParams();
  const item = posts.find((post) => post?.title && blogSlug(post.title) === name.toLowerCase());
  const hasContentHeading = useMemo(() => {
    if (!item?.content || typeof DOMParser === "undefined") return false;
    return Boolean(new DOMParser().parseFromString(item.content, "text/html").querySelector("h1"));
  }, [item?.content]);
  const Title = hasContentHeading ? "p" : "h1";

  if (!item && (loading || error)) {
    return (
      <>
        <Navbar2 />
        <main className="public-page-state" aria-busy={loading} data-voices-theme="dark">
          <h1>{loading ? "Loading article" : "Article temporarily unavailable"}</h1>
          {error && !loading && (
            <div role="alert">
              <p>The article could not be loaded. Please try again.</p>
              <button type="button" onClick={onRetry}>Try again</button>
            </div>
          )}
        </main>
      </>
    );
  }
  if (!item) return <NotFound />;

  return (
    <>
      <Navbar2 />
      <main className="v-blog-page" data-voices-theme="dark">
        <section style={{ padding: "8rem 0 0" }}>
          <Container>
            <Title className="blogDatial-heading">{item.title}</Title>
            {item.authorName && (
              <div className="authors">
                {item.authorImage && (
                  <div className="author-pictures">
                    <div className="image" role="img" aria-label={item.authorName}
                      style={{ backgroundImage: `url(${item.authorImage})` }} />
                  </div>
                )}
                <div className="info">
                  <div className="author-names"><p>{item.authorName}</p></div>
                  <div className="post-date">{item.created_date}</div>
                </div>
              </div>
            )}
          </Container>
        </section>
        <section style={{ margin: 0, padding: "1rem" }}>
          <Container dangerouslySetInnerHTML={{ __html: item.content || "" }}
            style={{ padding: "1rem" }} className="blog_html_css" />
        </section>
      </main>
      <SetMeeting />
    </>
  );
}




